module.exports = __webpack_public_path__ + "img/symbol_2.e8b58208.png";